var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeliveryIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.16,
    height: 20.666,
    viewBox: "0 0 38.16 20.666",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_795",
    "data-name": "Groupe 795",
    transform: "translate(-165.633 -109.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_3",
    "data-name": "Union 3",
    d: "M28.645,19.6V12.544a1.119,1.119,0,0,1,.515-.93L36.6,7.305a1.046,1.046,0,0,1,1.562.93v5.333a5.075,5.075,0,0,1-2.3,3.994s-3.585,1.953-5.719,3a1.068,1.068,0,0,1-.456.106A1.055,1.055,0,0,1,28.645,19.6Zm-2.677.965c-2.129-1.045-5.719-3-5.719-3a5.081,5.081,0,0,1-2.292-3.994V8.235a1.044,1.044,0,0,1,1.56-.93l7.434,4.309a1.127,1.127,0,0,1,.519.93V19.6a1.055,1.055,0,0,1-1.047,1.071A1.072,1.072,0,0,1,25.968,20.561ZM9.4,16.72a1.158,1.158,0,1,1,0-2.316h3.526a1.158,1.158,0,1,1,0,2.316ZM4.7,11.5a1.16,1.16,0,1,1,0-2.32h8.22a1.16,1.16,0,1,1,0,2.32Zm22.828-.884L19.571,6.012a1.047,1.047,0,0,1-.281-1.6,3.683,3.683,0,0,1,1-.813L25.9.5a4.921,4.921,0,0,1,4.34,0l5.608,3.1a3.954,3.954,0,0,1,1,.813,1.068,1.068,0,0,1-.3,1.6L28.582,10.62a1.007,1.007,0,0,1-.521.142A1.063,1.063,0,0,1,27.528,10.62ZM1.169,6.281a1.157,1.157,0,1,1,0-2.314H12.921a1.157,1.157,0,1,1,0,2.314Z",
    transform: "translate(165.633 109.002)",
    fill: "#0f5ee9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryIcon);
export default __webpack_public_path__ + "static/media/delivery_icon.43d88fd6.svg";
export { ForwardRef as ReactComponent };